import React from 'react';
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {SeasonForm} from "../../../components/admin/season/SeasonForm";

export const Add = () => {
  return (
    <>
      <BoxTitle title="Ajouter une saison"/>
      <SeasonForm />
    </>
  )
}
